import { Route, Routes } from 'react-router-dom';
import './App.css';
import WebsiteRoutes from './Utils/AppRoutes/WebsiteRoutes/WebsiteRoutes';
import RiteAdminRoutes from './Utils/AppRoutes/RiteAdminRoutes/RiteAdminRoutes';
import ClientRoutes from './Utils/AppRoutes/ClientRoutes/ClientRoutes';
import RestaurantCustomerRegisterForm from './Components/RestaurantCustomer/RestaurantCustomerRegisterForm';
import T1Navbar from './Container/Themes/ThemeOne/T1Navbar';
import T1Menu from './Container/Themes/ThemeOne/T1Menu';
import T1MenuDetailsPage from './Container/Themes/ThemeOne/T1MenuDetailsPage';

function App() {
  return (
    <div className="App">
     <Routes>
        <Route path="/*" element={<WebsiteRoutes/>} />
        <Route path="/rite-admin/*" element={<RiteAdminRoutes />} />
        <Route path="/client-view/*" element={<ClientRoutes />} />
        {/* Theme Iframe */}
        <Route path="/customer-signup" element={<RestaurantCustomerRegisterForm />} />
        <Route path="/t1-navbar" element={<T1Navbar />} />
        <Route path="/t1-menu" element={<T1Menu />} />
        <Route path="/t1-menu/:id" element={<T1MenuDetailsPage />} />
</Routes>
    </div>
  );
}

export default App;
